export class Scenario {
  name = '';
  color = '';
  interval = 0;
  unitText = '';
}
